import { render, staticRenderFns } from "./ExtTestemunhos.vue?vue&type=template&id=d7441336&scoped=true&"
import script from "./ExtTestemunhos.vue?vue&type=script&lang=js&"
export * from "./ExtTestemunhos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7441336",
  null
  
)

export default component.exports